import { WORKER_URL } from '../../../js/config.js';
import { getSession } from '../../../js/utils/auth_utils.js';
import { fetchCache } from '../../../js/utils/fetchCache.js';

const FAVORITES_CHARACTERS_URL = `${WORKER_URL}/favorites/characters`;

const authHeaders = (accessToken) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${accessToken}`
});

export const getUserFavoriteCharacters = async (userId) => {
  if (!userId) {
    throw new Error('User ID is required');
  }

  try {
    const session = await getSession();
    if (!session?.access_token) {
      throw new Error('Authentication required for favorite characters');
    }
    const result = await fetchCache.fetchJSON(FAVORITES_CHARACTERS_URL, {
      method: 'GET',
      headers: authHeaders(session.access_token)
    });

    if (!result.success) {
      throw new Error(result.error || 'Failed to fetch favorite characters');
    }

    return result.data;
  } catch (error) {
    console.error('Error fetching favorite characters:', error);
    throw error;
  }
};

export const toggleFavoriteCharacter = async (userId, characterId) => {
  if (!userId || !characterId) {
    throw new Error('User ID and Character ID are required');
  }

  try {
    const session = await getSession();
    if (!session?.access_token) {
      throw new Error('Authentication required for toggling favorites');
    }
    const response = await fetch(`${WORKER_URL}/favorites/toggle`, {
      method: 'POST',
      headers: authHeaders(session.access_token),
      body: JSON.stringify({
        character_id: characterId
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.error || 'Failed to toggle favorite');
    }

    fetchCache.invalidate(FAVORITES_CHARACTERS_URL);
    return result;
  } catch (error) {
    console.error('Error toggling favorite:', error);
    throw error;
  }
};
